import React from 'react';
import './HomePageLoader.css';
import {CircularProgress, Typography} from "@mui/material";

const HomePageLoader = () => {
    return (
        <div className="homepage-loader-container">
            <div className="homepage-loader-big">
                <img
                    src={process.env.PUBLIC_URL + "/headerdata/tacsa_logo.svg"}
                    alt="Tacsa Logo"
                    className="pulse-logo"
                />
                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 'bold',
                        color: 'rgba(255, 255, 255, 0.9)',
                        mb: 1,
                    }}
                >
                    პორტალი იტვირთება...
                </Typography>
                <Typography
                    sx={{
                        fontSize: 14,
                        fontWeight: 'normal',
                        color: 'rgba(255, 255, 255, 0.7)',
                        mb: 3,
                    }}
                >
                    გთხოვთ დაელოდოთ
                </Typography>
                <CircularProgress sx={{color: 'rgba(255, 255, 255, 0.8)'}}/>
            </div>
            <div className="homepage-loader-small-container">
                <div>
                    <div className="homepage-loader-small"></div>
                </div>
                <div>
                    <div className="homepage-loader-small-news"></div>
                    <div className="homepage-loader-small-news"></div>
                </div>
            </div>
        </div>
    );
}

export default HomePageLoader;
